import script from "./SubLoading.vue?vue&type=script&setup=true&lang=ts"
export * from "./SubLoading.vue?vue&type=script&setup=true&lang=ts"

import "./SubLoading.vue?vue&type=style&index=0&id=27347b18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27347b18"]])

export default __exports__